import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import AboutPage from "@/pages/about/page";
import ServicesIndexPage from "@/pages/services/page";
import HouseShiftingPage from "@/pages/services/house-shifting/page";
import OfficeShiftingPage from "@/pages/services/office-shifting/page";
import StorageServicePage from "@/pages/services/storage/page";
import LocalShiftingPage from "@/pages/services/local-shifting/page";
import AreasIndexPage from "@/pages/areas/page";
import AreaDetailPage from "@/pages/areas/detail/page";
import WarehousePage from "@/pages/warehouse/page";
import HighlightsPage from "@/pages/highlights/page";
import GalleryPage from "@/pages/gallery/page";
import ContactPage from "@/pages/contact/page";
import RequestAQuotePage from "@/pages/request-a-quote/page";
import TermsPage from "@/pages/terms/page";
import PrivacyPage from "@/pages/privacy/page";
import SecurityDashboardPage from "@/pages/admin/security/page";
import SeoDashboardPage from "@/pages/admin/seo/page";

const routes: RouteObject[] = [
  {
    path: "/admin/security",
    element: <SecurityDashboardPage />,
  },
  {
    path: "/admin/seo",
    element: <SeoDashboardPage />,
  },
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "about",
        element: <AboutPage />,
      },
      {
        path: "services",
        element: <ServicesIndexPage />,
      },
      {
        path: "services/house-shifting",
        element: <HouseShiftingPage />,
      },
      {
        path: "services/office-shifting",
        element: <OfficeShiftingPage />,
      },
      {
        path: "services/storage",
        element: <StorageServicePage />,
      },
      {
        path: "services/local-shifting",
        element: <LocalShiftingPage />,
      },
      {
        path: "areas-we-serve",
        element: <AreasIndexPage />,
      },
      {
        path: "areas-we-serve/:slug",
        element: <AreaDetailPage />,
      },
      {
        path: "warehouse",
        element: <WarehousePage />,
      },
      {
        path: "highlights",
        element: <HighlightsPage />,
      },
      {
        path: "gallery",
        element: <GalleryPage />,
      },
      {
        path: "contact",
        element: <ContactPage />,
      },
      {
        path: "request-a-quote",
        element: <RequestAQuotePage />,
      },
      {
        path: "terms",
        element: <TermsPage />,
      },
      {
        path: "privacy",
        element: <PrivacyPage />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;